module.exports = __webpack_public_path__ + "static/media/award3.a7957eeb.jpeg";